<template>
    <div v-if="orden">
        <div class="nj-flx">
            <button :disabled="files == null" @click="uploadFiles" class="button is-success is-small">Cargar Archivos</button>
            <b-field>
                <b-upload v-model="files" :disabled="files != null">
                    <a class="button is-primary is-small">
                        <b-icon icon="upload"></b-icon>
                        <span>Subir tu archivo</span>
                    </a>
                </b-upload>
            </b-field>
        </div>
        <div class="tags">
            <span v-for="(file, index) in files" :key="index" class="tag is-primary">
                {{ file.name }}
                <button class="delete is-small" type="button" @click="deleteDropFile(index)"></button>
            </span>
        </div>
        <b-table v-if="archivos" :data="archivos" bordered>
            <template slot-scope="props">
                <b-table-column label="Descripción">
                    <a href="#" @click.prevent="retrieveFile(props.row)">{{ props.row.file_name }}</a>
                </b-table-column>
                <b-table-column label="Tamaño">
                    {{ props.row.size | bytes }}
                </b-table-column>
            </template>
        </b-table>
    </div>
</template>

<script>
import axios from "axios"

export default {
    name: "OrdenArchivos",
    props: ["orden"],
    data() {
        return {
            archivos: [],
            files: null
        }
    },
    methods: {
        loadFiles() {
            axios.post('/orden/file/list', {
                id_orden: this.getIdOrden()
            }).then(
                (resp) => this.archivos = resp.data
            )
        },
        getIdOrden() {
            let path = window.location.pathname
            return path.split("/")[3]
        },
        deleteDropFile(index) {
            // this.files.splice(index, 1)
            this.files = null
        },
        uploadFiles() {
            let form = new FormData()
            form.append("id_orden", this.getIdOrden())
            // form.append("file", this.files[0])
            form.append("file", this.files)
            axios
                .post("/orden/file/save", form)
                .then(() => {
                    // this.files = []
                    this.files = null
                    this.loadFiles()
                })
            // .post("/orden/file/save", form, {
            //     headers: {
            //         "Content-Type": "multipart/form-data"
            //     }
            // })
            // .then(() => {
            //     this.files = []
            //     this.loadFiles()
            // })
        },
        retrieveFile(row) {
            axios({
                method: "POST",
                responseType: "blob",
                url: "/orden/file/retrieve",
                data: row
            }).then(response => {
                let fileURL = window.URL.createObjectURL(new Blob([response.data]))
                let fileLink = document.createElement("a")
                fileLink.href = fileURL
                fileLink.setAttribute("download", row.file_name)
                document.body.appendChild(fileLink)
                fileLink.click()
            })
        }
    },
    mounted() {
        this.loadFiles()
    }
}
</script>

<style scoped></style>
